<template>
  <el-form
    ref="flightDataForm"
    :model="model"
    :rules="rules"
    label-width="10em"
    label-position="left"
    class="flight-data-form"
  >
    <div class="el-form--inline">
      <BillingYm v-model="billingYm" :required="searchMode" :disabled="editMode" :mode="billingYmMode" :autofocus="!editMode" :searchCond="searchMode" :actualprop=true />
      <Blank />
    </div>
    <el-divider />
    <div class="el-form--inline">
      <ActionType v-model="actionType" label="着離陸区分" :disabled="editMode" mode="flightAction" :searchCond="searchMode" />
      <Callsign v-model="callsign" :disabled="editMode" :searchCond="searchMode" />
    </div>
    <div class="el-form--inline">
      <RouteCode v-model="routeCode" :disabled="editMode" :searchCond="searchMode" />
      <ModelCode v-model="modelCode" :disabled="editMode" :autocomplete-list="autocompleteModelCodeSet" :searchCond="searchMode" />
    </div>
    <el-divider />
    <div class="el-form--inline">
      <AirportCode v-model="departureAirportCode" label="出発地" prop="departure_airport_code" :disabled="editMode"
        :autocomplete-list="autocompleteAirportCodeSet" :searchCond="searchMode" />
      <AirportCode v-model="destinationAirportCode" label="目的地" prop="destination_airport_code" :disabled="editMode"
        :autocomplete-list="autocompleteAirportCodeSet" :searchCond="searchMode" />
    </div>
    <div class="el-form--inline">
      <CustomerCode v-model="operatorCode" label="運航者" prop="operator_code" :disabled="editMode"
        :autocomplete-list="autocompleteCustomerCodeSet"  :searchCond="searchMode"/>
      <FlightPurposeCode v-model="flightPurposeCode" label="飛行目的" :disabled="editMode" :searchCond="searchMode" />
    </div>
    <div class="el-form--inline">
      <RegistrationSymbol v-model="registrationSymbol" :disabled="editMode" :searchCond="searchMode"
        :autocomplete-list="autocompleteRegistrationSymbolSet" />
      <CargoPassengerType v-model="cargoPassengerType" :disabled="editMode" :searchCond="searchMode" :initialize="true"  />
    </div>
    <el-divider />
    <template v-if='formMode === "search"'>
      <DateTimeRange :dateTimeFrom.sync="actualTimeDepartureFrom" :dateTimeTo.sync="actualTimeDepartureTo" label="ATD"
        :searchCond="searchMode" :disabled="editMode" />
      <DateTimeRange :dateTimeFrom.sync="actualTimeArrivalFrom" :dateTimeTo.sync="actualTimeArrivalTo" label="ATA"
        :searchCond="searchMode" :disabled="editMode" />
    </template>
    <template v-else>
      <div class="el-form--inline">
        <DateTime v-model="actualTimeDeparture" label="ATD" prop="actual_time_departure" :disabled="editMode" />
        <DateTime v-model="actualTimeArrival" label="ATA" prop="actual_time_arrival" :disabled="editMode" />
      </div>
    </template>
    <el-divider />
    <div class="el-form--inline">
      <Irregular v-model="irregular" :disabled="editMode" :searchCond="searchMode" :initialize="true" />
      <AirportCode v-model="divertAirportCode" label="ダイバート先" prop="divert_airport_code" :disabled="editMode"
        :autocomplete-list="autocompleteAirportCodeSet" :searchCond="searchMode" />
    </div>
  </el-form>
</template>

<script>
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import ActionType from '@/components/molecules/form/select/ActionType.vue'
import Callsign from '@/components/molecules/form/text/Callsign.vue'
import RouteCode from '@/components/molecules/form/select/RouteCode.vue'
import ModelCode from '@/components/molecules/form/autocomplete/ModelCode.vue'
import AirportCode from '@/components/molecules/form/autocomplete/AirportCode.vue'
import CustomerCode from '@/components/molecules/form/autocomplete/CustomerCode.vue'
import RegistrationSymbol from '@/components/molecules/form/autocomplete/RegistrationSymbol.vue'
import FlightPurposeCode from '@/components/molecules/form/select/FlightPurposeCode.vue'
import CargoPassengerType from '@/components/molecules/form/select/CargoPassengerType.vue'
import DateTime from '@/components/molecules/form/date/DateTime.vue'
import DateTimeRange from '@/components/molecules/form/date/DateTimeRange.vue'
import Irregular from '@/components/molecules/form/select/Irregular.vue'
import Blank from '@/components/molecules/form/text/Blank.vue'

export default {
  components: {
    BillingYm,
    ActionType,
    Callsign,
    RouteCode,
    ModelCode,
    AirportCode,
    CustomerCode,
    RegistrationSymbol,
    FlightPurposeCode,
    CargoPassengerType,
    DateTime,
    DateTimeRange,
    Irregular,
    Blank
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    formMode: {
      type: String,
      default: 'search'
    },
    rules: Object,
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {}
  },
  computed: {
    billingYm: {
      get () {
        return this.model.billing_ym
      },
      set (billingYm) {
        const form = { ...this.model }
        form.billing_ym = billingYm
        this.$emit('input', form)
      }
    },
    actionType: {
      get () {
        return this.model.action_type
      },
      set (actionType) {
        const form = { ...this.model }
        form.action_type = actionType
        this.$emit('input', form)
      }
    },
    callsign: {
      get () {
        return this.model.callsign
      },
      set (callsign) {
        const form = { ...this.model }
        form.callsign = callsign
        this.$emit('input', form)
      }
    },
    routeCode: {
      get () {
        return this.model.route_code
      },
      set (routeCode) {
        const form = { ...this.model }
        form.route_code = routeCode
        this.$emit('input', form)
      }
    },
    modelCode: {
      get () {
        return this.model.model_code
      },
      set (modelCode) {
        const form = { ...this.model }
        form.model_code = modelCode
        this.$emit('input', form)
      }
    },
    departureAirportCode: {
      get () {
        return this.model.departure_airport_code
      },
      set (departureAirportCode) {
        const form = { ...this.model }
        form.departure_airport_code = departureAirportCode
        this.$emit('input', form)
      }
    },
    destinationAirportCode: {
      get () {
        return this.model.destination_airport_code
      },
      set (destinationAirportCode) {
        const form = { ...this.model }
        form.destination_airport_code = destinationAirportCode
        this.$emit('input', form)
      }
    },
    operatorCode: {
      get () {
        return this.model.operator_code
      },
      set (operatorCode) {
        const form = { ...this.model }
        form.operator_code = operatorCode
        this.$emit('input', form)
      }
    },
    flightPurposeCode: {
      get () {
        return this.model.flight_purpose_code
      },
      set (flightPurposeCode) {
        const form = { ...this.model }
        form.flight_purpose_code = flightPurposeCode
        this.$emit('input', form)
      }
    },
    registrationSymbol: {
      get () {
        return this.model.registration_symbol
      },
      set (registrationSymbol) {
        const form = { ...this.model }
        form.registration_symbol = registrationSymbol
        this.$emit('input', form)
      }
    },
    cargoPassengerType: {
      get () {
        return this.model.cargo_passenger_type
      },
      set (cargoPassengerType) {
        const form = { ...this.model }
        form.cargo_passenger_type = cargoPassengerType
        this.$emit('input', form)
      }
    },
    actualTimeArrival: {
      get () {
        return this.model.actual_time_arrival
      },
      set (actualTimeArrival) {
        const form = { ...this.model }
        form.actual_time_arrival = actualTimeArrival
        this.$emit('input', form)
      }
    },
    actualTimeArrivalFrom: {
      get () {
        return this.model.actual_time_arrival_from
      },
      set (actualTimeArrivalFrom) {
        const form = { ...this.model }
        form.actual_time_arrival_from = actualTimeArrivalFrom
        this.$emit('input', form)
      }
    },
    actualTimeArrivalTo: {
      get () {
        return this.model.actual_time_arrival_to
      },
      set (actualTimeArrivalTo) {
        const form = { ...this.model }
        form.actual_time_arrival_to = actualTimeArrivalTo
        this.$emit('input', form)
      }
    },
    actualTimeDeparture: {
      get () {
        return this.model.actual_time_departure
      },
      set (actualTimeDeparture) {
        const form = { ...this.model }
        form.actual_time_departure = actualTimeDeparture
        this.$emit('input', form)
      }
    },
    actualTimeDepartureFrom: {
      get () {
        return this.model.actual_time_departure_from
      },
      set (actualTimeDepartureFrom) {
        const form = { ...this.model }
        form.actual_time_departure_from = actualTimeDepartureFrom
        this.$emit('input', form)
      }
    },
    actualTimeDepartureTo: {
      get () {
        return this.model.actual_time_departure_to
      },
      set (actualTimeDepartureTo) {
        const form = { ...this.model }
        form.actual_time_departure_to = actualTimeDepartureTo
        this.$emit('input', form)
      }
    },
    irregular: {
      get () {
        return this.model.irregular
      },
      set (irregular) {
        const form = { ...this.model }
        form.irregular = irregular
        this.$emit('input', form)
      }
    },
    divertAirportCode: {
      get () {
        return this.model.divert_airport_code
      },
      set (divertAirportCode) {
        const form = { ...this.model }
        form.divert_airport_code = divertAirportCode
        this.$emit('input', form)
      }
    },
    updateDate: {
      get () {
        return this.model.updated_on
      },
      set (updateDate) {
        const form = { ...this.model }
        form.updated_on = updateDate
        this.$emit('input', form)
      }
    },
    searchMode: {
      get () {
        return this.formMode === 'search'
      }
    },
    editMode: {
      get () {
        return this.formMode === 'edit'
      }
    }
  },
  mounted () {
  },
  methods: {
    clearFields () {
      this.$refs.flightDataForm.resetFields()
      if (this.searchMode) {
        this.model.actual_time_arrival_from = null
        this.model.actual_time_arrival_to = null
        this.model.actual_time_departure_from = null
        this.model.actual_time_departure_to = null
      }
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.flightDataForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.flight-data-form {
  .el-form--inline {
    display: flex;
    justify-content: space-between;
  }
  // .el-input.is-disabled .el-input__inner{
  //   color: #606266
  // }
}
</style>
